module.exports = __webpack_public_path__ + "img/lodka.63f8e9b6.jpg";